<ng-template #content let-c="close" let-d="dismiss">
    <form name="frm" id="frm" (submit)="SendMessage()">
        <div class="modal-header">
            <h6 class="modal-title" >{{'TITLE.TITLE_SEND_MSG' | translate}} <span *ngIf="JobData"> ({{JobData.DisplayCallNo}} | {{JobData.CallDescription}})</span></h6>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;
                </span>
            </button>
        </div>
        <div class="modal-body">
            <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
            <div class="row form-group" *ngIf="lstProperties && lstProperties.length > 1" [hidden]="Selectable == false">
                <label class="col-2 col-form-label" translate>LBL.PROPERTY</label>
                <div class="col">
                    <select class="custom-select" id="PropertyId" name="PropertyId" [(ngModel)]="Model.PropertyId" (change)="onPropertyChange()">
                        <option *ngFor="let row of lstProperties" [value]="row.PropertyId">{{row.PropertyName}}</option>
                    </select>
                </div>
            </div>
            <div class="row form-group" [hidden]="Selectable == false">
                <div class="offset-2 col">
                    <div class="custom-control custom-radio custom-control-inline" *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.StaffMessage)">
                        <input type="radio" class="custom-control-input" name="SendMessageDestinationType" id="SendMessageDestinationType_1" [value]="1" [(ngModel)]="Model.SendMessageDestinationType">
                        <label class="custom-control-label" for="SendMessageDestinationType_1" translate>LBL.STAFF</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline" *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GroupMessage)">
                        <input type="radio" class="custom-control-input" name="SendMessageDestinationType" id="SendMessageDestinationType_2" [value]="2" [(ngModel)]="Model.SendMessageDestinationType">
                        <label class="custom-control-label" for="SendMessageDestinationType_2" translate>LBL.GROUP_NAME</label>
                    </div>
                </div>
            </div>
            <div class="row form-group align-items-center" [hidden]="Selectable == false">
                <label class="req col-2 col-form-label" [ngSwitch]="Model.SendMessageDestinationType">
                    <span *ngSwitchCase="_SendMessageDestinationTypes.Staff" translate>LBL.STAFF</span>
                    <span *ngSwitchCase="_SendMessageDestinationTypes.Group" translate>LBL.GROUP_NAME</span>
                </label>
                <div class="col">
                    <select class="custom-select" id="StaffId" name="StaffId" [(ngModel)]="Model.StaffId" [hidden]="Model.SendMessageDestinationType != _SendMessageDestinationTypes.Staff" *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.StaffMessage)">
                        <option value="0" translate>CMB_DEF.CMB_DEF_SELECT_STAFF</option>
                        <option *ngFor="let row of StaffListModel" [value]="row.Id">{{row.Name}}</option>
                    </select>
                    <select class="custom-select" id="GroupId" name="GroupId" [(ngModel)]="Model.GroupId" [hidden]="Model.SendMessageDestinationType != _SendMessageDestinationTypes.Group" *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GroupMessage)">
                        <option value="0" translate>CMB_DEF.CMB_DEF_SELECT_GROUP</option>
                        <option *ngFor="let row of GroupListModel" [value]="row.Id">{{row.Name}}</option>
                    </select>
                </div>
            </div>
            <div class="row form-group">
                <div class="col">
                    <textarea id="Message" name="Message" class="form-control" [(ngModel)]="Model.Message" placeholder="{{'PH.PH_MSG_LENGTH_1000' | translate}}" maxlength="1000"></textarea>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" type="submit" translate>BTN.BTN_SEND</button>
            <button class="btn btn-secondary" aria-label="Close" (click)="d('Cross click')" type="button" translate>BTN.BTN_CANCEL</button>
        </div>
    </form>
</ng-template>
